import BaseAPI from "../api";

const path: string = "/advisor-estimate-score";

export type listType = {
  degree?: string;
  faculty?: string;
  date_of_issue?: string;
  year_graduated?: string;
  status?: string;
  created_id?: string;
  created_date?: string;
  modified_id?: string;
  modified_date?: number;
  type?: string;
  limit?: number;
  page?: number;
  keyword?: string;
  search?: string;
};

export class advisorEstimateScoreApi extends BaseAPI {
  static getScoreWithIdAdvisorEstimate(
    id_advisor_estimate: number,
    query: any
  ): Promise<any> {
    return this.api.get(`${path}/${id_advisor_estimate}/advisor-estimate`, {
      params: { ...query },
    });
  }

  static getScoreWithIdCourseAnnualEmployee(
    id_coures_annual_employee: number,
    query: any
  ): Promise<any> {
    return this.api.get(
      `${path}/${id_coures_annual_employee}/advisor-estimate-form-student`,
      {
        params: { ...query },
      }
    );
  }

  static getCourseStudentEstimateByIdCouresAnnual(
    id_coures_annual: number,
    query: any
  ): Promise<any> {
    return this.api.get(`${path}/${id_coures_annual}/course-student-estimate`, {
      params: { ...query },
    });
  }

  static getCourseAnnualEmployeeByIdCourseOfStudy(
    id_coures_annual: number,
    query: any
  ): Promise<any> {
    return this.api.get(`${path}/${id_coures_annual}/course-annual-employee`, {
      params: { ...query },
    });
  }

  static getCourseAnnualEmployeeByIdCourseOfStudyAndIdEmployee(
    id_coures_annual: number,
    id_employee: number,
    query: any
  ): Promise<any> {
    return this.api.get(
      `${path}/${id_coures_annual}/course-employee/${id_employee}`,
      {
        params: { ...query },
      }
    );
  }

  static getCourseOfStudy(query: any): Promise<any> {
    return this.api.get(`${path}/courses-of-study`, {
      params: { ...query },
    });
  }
}
